import { NetworkChatIcon,NetworkCallIcon } from '@mybridge/icons';
import {
  Button,
  Card,
  Divider,
  HStack,
  IconButton,
  Spinner,
  Stack,
  Text,
  Wrap,
  WrapItem,
  useDisclosure
} from '@mybridge/ui';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { forwardRef, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { SearchCardSkeleton } from 'v4/snippets/search/search-card-skeleton';
import { startChatWithUser  } from 'v4/store/actions/chat.actions';
import { NetworkListingNotFound } from '../../404';
import { MyNetworkCircleCardMenu } from '../circle-menu';
import { MyNetworkCircleFilters } from '../my-circle-filters';
import { ConsoleView, isMobile } from 'react-device-detect';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import InfiniteScroll from 'react-infinite-scroll-component';
import MyNetworkSearchInput from 'v4/components/network/network-search-input';
import { useRouter } from 'next/router';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { getUserFullName } from 'v4/lib/commons';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { GlobalMatrixPopup } from 'v4/snippets/globalMatrixPopup';
import { getMatrixUserId } from 'v4/utils/utils';

export const MyNetworkCircleListing = forwardRef(({ limit, ...props }, ref) => {
  const {
    searchQuery,
    setSearchQuery,
    refetchMyFirstDegreeConnections,
    myFirstDegreeConnections: listing,
    myFirstDegreeConnectionsIsFetching,
    myFirstDegreeConnectionsIsLoading,
    myFirstDegreeConnectionsCount,
    MyFirstDegreeConnectionsHasNextPage,
    MyFirstDegreeConnectionsFetchNextPage,
    myFirstDegreeConnectionsPagingCount,
    userProfileInfo,
  } = useContext(MyNetworkContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [confirmAction, setConfirmAction] = useState(() => () => {});
  const { t } = useTranslator();
const userSlug = userProfileInfo?.slug || 'anonymous';
  const dispatch = useDispatch()
  const { initiateCall, startChatSingle, connectionList } = useContext(MatrixContext);
  const { formatNumber } = useNumberFormatter();
  // useEffect(() => {
  //   if (userProfileInfo?.id) {
  //     refetchMyFirstDegreeConnections?.();
  //   }
  // }, [userProfileInfo]);

  useEffect(()=>{
    trackEvent(ANALYTICS_EVENTS.ManageConnection,userSlug)
    trackEvent(ANALYTICS_EVENTS.MyCircleScreen, userSlug);
  },[userSlug])
  useEffect(() => {
    // refetchMyFirstDegreeConnections?.();
    
    // Cleanup function to reset searchQuery when component unmounts
    return () => {
      setSearchQuery('');
    };
  }, []);

  const displayedConnections = useMemo(() => {
    let filtered = listing;
    if (searchQuery?.length > 0) {
      filtered = listing?.filter((user) => {
        const name = getUserFullName(user)?.toLowerCase?.();
        return name?.includes(searchQuery?.toLowerCase());
      });
    }
    return limit ? filtered?.slice(0, limit) : filtered;
  }, [listing, limit, searchQuery]);

  
  const { pathname, push } = useRouter();

  // Define which paths should show limited cards
  const isNetworkPage = pathname === '/profile/network';
  
  // Check if we have connections but no search results
  const hasConnections = (listing?.length > 0);
  const hasNoSearchResults = hasConnections && searchQuery?.length > 0 && displayedConnections?.length === 0;
  
  return (
    <>
      {myFirstDegreeConnectionsIsLoading ? (
        <HStack w="100%" justifyContent="center">
          <Spinner />
        </HStack>
      ) : (
        <>
          {/* Show header with count and search input if we have connections or if searching with no results */}
          {(hasConnections || hasNoSearchResults) && !isNetworkPage && (
            <>
              <HStack w="100%" justifyContent="space-between" alignItems={["flex-start","center"]} px={3}>
               <Text
                  fontSize={['14px', '16px']}
                  color="#868585"
                  alignment={["start","center"]}
                  visibility={searchQuery?.length > 0 ? 'hidden' : 'visible'}
                >
                  {formatNumber(myFirstDegreeConnectionsCount)}{' '}
                  {!isMobile 
                    ? myFirstDegreeConnectionsCount === 1 
                      ? t('profile.connection') || 'Connection' 
                      : t('profile.connections') || 'Connections' 
                    : t('profileNetwork.firstDegreeConnections') || '1st Degree Connections'}
                </Text>
                {!isMobile && <MyNetworkSearchInput searchType="myFirstDegree" />}
              </HStack>
              {isMobile && <Divider my={4} />}
            </>
          )}

          {/* Show connections if we have search results */}
          {displayedConnections?.length > 0 ? (
            <InfiniteScroll
              dataLength={displayedConnections.length}
              next={MyFirstDegreeConnectionsFetchNextPage}
              hasMore={MyFirstDegreeConnectionsHasNextPage}
              loader={myFirstDegreeConnectionsIsFetching?
                <HStack pb={5} justifyContent="center" w="100%">
                  <Spinner />
                </HStack>:""
              }
              scrollableTarget="myFirstDegreeConnectionsContainer"
            >
              <Wrap id="myFirstDegreeConnectionsContainer"
                spacing={2}
                p={3}
                pt="20px" 
                overflow="auto"
                height="75vh"
                sx={{
                  scrollbarWidth: 'none', 
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                }}
              >
                {displayedConnections?.map((cu) => (
                  <WrapItem
                    key={cu?.id}
                    maxW={['49%', '30%', '190px']}
                    flexGrow={['1', '1', 0]}
                    flexShrink={['1', '1', 0]}
                    flex="auto"
                  >
                    <MyNetworkUserCardBordered
                      user={cu}
                      width="100%"
                      actions={
                        <HStack justifyContent="center">
                          <IconButton
                            icon={<NetworkChatIcon width="18px" height="18px" color="#9F9F9F" />}
                            // onClick={() => startChatSingle(cu)}
                            onClick={() => {
                              // const matrixUserId = getMatrixUserId(cu?.id);
                
                              // if (!(cu?.connection?.chat_room_id || matrixUserId)) {
                              //   setConfirmAction(() => (newId) => {
                              //     push(`/profile/message?user=${newId}`);
                              //   });
                              //   onOpen();
                              // } else {
                              //   push(`/profile/message?user=${cu?.matrix_user_id || matrixUserId}`);
                              // }
                              push(`/profile/message?user=${cu?.connection?.room_id}`);
                            }}
                            bg="none"
                            width="30px"
                            height="40px"
                            borderRadius="50%"
                            border="1px solid #00000033"
                          />
                          <IconButton
                            icon={<NetworkCallIcon/>}
                            // onClick={(e) => {
                            //   if (!cu?.matrix_user_id) {
                            //     onOpen(); // show matrix popup
                            //   } else {
                            //     initiateCall(cu?.matrix_user_id,'audio')
                            //   }
                            // }}
                            onClick={() => {
                              // const matrixUserId = getMatrixUserId(cu?.id);

                              // if (!(cu?.connection?.chat_room_id || matrixUserId)) {
                              //   setConfirmAction(() => (newId) => {
                              //     initiateCall(newId, 'audio');
                              //   });
                              //   onOpen();
                              // } else {
                              //   initiateCall(cu?.matrix_user_id || matrixUserId, 'audio');
                              // }
                              initiateCall(cu);
                            }}
                            bg="none"
                            width="30px"
                            height="40px"
                            borderRadius="50%"
                            border="1px solid #00000033"
                            // isDisabled={connectionList.length === 0}
                          />
                          <MyNetworkCircleCardMenu user={cu} />
                          <GlobalMatrixPopup
                            isOpen={isOpen}
                            onClose={onClose}
                            onConfirm={confirmAction}
                            selectedUserId={cu?.id}
                          />
                        </HStack>
                      }
                    />
                  </WrapItem>
                ))}
              </Wrap>
              {MyFirstDegreeConnectionsHasNextPage && !myFirstDegreeConnectionsIsFetching && (
                <HStack justifyContent="center" py={3} pt={0}>
                  <Text fontSize="sm" color="gray.500">
                    Scroll down to load more connections ↓
                  </Text>
                </HStack>
              )}
              {isMobile && <Divider my={4} />}
            </InfiniteScroll>
          ) : (
            <>
              {/* Show "No users found" message if searching with no results */}
              {hasNoSearchResults ? (
                <HStack justifyContent="center">
                  <Stack alignItems="center">
                    <NetworkListingNotFound />
                    <Text>{t('scheduling.noUserFound') || "No User Found"}</Text>
                  </Stack>
                </HStack>
              ) : myFirstDegreeConnectionsIsFetching ? (
                <HStack justifyContent="center">
                  <Stack alignItems="center">
                    <Spinner/>
                  </Stack>
                </HStack>
              ):(
                /* Show default empty state if no connections at all */
                !isNetworkPage && !myFirstDegreeConnectionsIsFetching && (
                  <HStack justifyContent="center">
                    <Stack alignItems="center">
                      <NetworkListingNotFound />
                      <Text>{t('myMessages.noFirstDegreeConnection')}</Text>
                      {/* {t('profileNetwork.manageInvitations') || "Manage Invitations"} */}
                    </Stack>
                  </HStack>
                )
              )}
            </>
          )}
        </>
      )}
    </>
  );
});
